module.exports = __webpack_public_path__ + "assets/img/robo_black_16px.1bf471d0.svg";